module.exports = __webpack_public_path__ + "static/media/productImg1.b7e5da9e.png";